module.exports = __webpack_public_path__ + "static/media/combat(11).6b79310a.PNG";